"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = exports.numberCV = exports.booleanCV = exports.traitCV = exports.principalCV = exports.responseSimpleEncoder = exports.listEncoder = exports.tupleEncoder = void 0;
const transactions_1 = require("@stacks/transactions");
const decoders_1 = require("./decoders");
function tupleEncoder(decorators) {
    return (input) => {
        const result = {};
        for (const key of Object.keys(decorators)) {
            result[key] = decorators[key](input[key]);
        }
        return (0, transactions_1.tupleCV)(result);
    };
}
exports.tupleEncoder = tupleEncoder;
function listEncoder(encoder) {
    return (value) => {
        return (0, transactions_1.listCV)(value.map(encoder));
    };
}
exports.listEncoder = listEncoder;
function responseSimpleEncoder(success) {
    return (value) => {
        if (value.type === "success") {
            return (0, transactions_1.responseOkCV)(success(value.value));
        }
        if (value.error instanceof decoders_1.ClarityError) {
            return (0, transactions_1.responseErrorCV)((0, transactions_1.uintCV)(value.error.code));
        }
        return (0, transactions_1.responseErrorCV)((0, transactions_1.stringUtf8CV)(value.error.message));
    };
}
exports.responseSimpleEncoder = responseSimpleEncoder;
function principalCV(principal) {
    if (principal.includes(".")) {
        const [address, contractName] = principal.split(".");
        return (0, transactions_1.contractPrincipalCV)(address, contractName);
    }
    else {
        return (0, transactions_1.standardPrincipalCV)(principal);
    }
}
exports.principalCV = principalCV;
const traitCV = (val) => {
    const [addr, name] = val.split(".");
    if (addr && name) {
        return (0, transactions_1.contractPrincipalCV)(addr, name);
    }
    throw new Error(`can not parse val as trait: ${val}`);
};
exports.traitCV = traitCV;
const booleanCV = (value) => {
    if (value) {
        return (0, transactions_1.trueCV)();
    }
    else {
        return (0, transactions_1.falseCV)();
    }
};
exports.booleanCV = booleanCV;
const numberCV = (input) => (0, transactions_1.uintCV)(input);
exports.numberCV = numberCV;
function optional(encoder) {
    return (value) => {
        if (value === undefined) {
            return (0, transactions_1.noneCV)();
        }
        return (0, transactions_1.someCV)(encoder(value));
    };
}
exports.optional = optional;
